import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $ from 'jquery'
import '@/assets/styles/public.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css';

import VueParticles from 'vue-particles'

Vue.use(ElementUI)
Vue.prototype.$layer = layer(Vue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueParticles)
Vue.config.productionTip = false

// 调用vue中的过滤器，固定第一个参数为传入的要处理的数据data
// Vue.filter('过滤器的名称',function(data){});
// 进行时间的格式化
Vue.filter('dateFormat', function (dateStr, time) {
  //得到特定的时间
  var date = new Date(dateStr);
  var year = date.getFullYear();
  //ES6语法填充：var month = (date.getMonth()+1).toString().padStart(2, '0');
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
  var mm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  //return `${year}-${month}-${day}`;
  if (time && time.toLowerCase() === 'yyyy-mm-dd') {
    return `${year}.${month}.${day}`;
  } else if (time && time.toLowerCase() === 'hh:mm:ss') {
    return `${hh}:${mm}:${ss}`;
  } else {
    return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
  }
});
// 使用方法
// {{endTime | dateFormat}}

Vue.filter('money', function (val) {
  val = val.toString().replace(/\$|\,/g, '');
  if (isNaN(val)) {
    val = "0";
  }
  let sign = (val == (val = Math.abs(val)));
  val = Math.floor(val * 100 + 0.50000000001);
  let cents = val % 100;
  val = Math.floor(val / 100).toString();
  if (cents < 10) {
    cents = "0" + cents
  }
  for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
    val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
  }
  return (((sign) ? '' : '-') + val + '.' + cents);
})
// 使用方法
// {{endTime | money}}

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')